"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUsersFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30.59 16.21A13.61 13.61 0 0023 14a14.18 14.18 0 00-7 1.85 19.56 19.56 0 012.62 1A12.37 12.37 0 0123 16a12.24 12.24 0 016 1.57V21h-7v2h9v-6.49zM17 19.4a17.84 17.84 0 00-2-.71 18.43 18.43 0 00-5-.69 16.78 16.78 0 00-8.54 2.18l-.46.29V27h18v-6.53l-.46-.29A10.17 10.17 0 0017 19.4zM10 16a3.86 3.86 0 002.84-1A4.69 4.69 0 0014 11.5C14 7.59 11.49 7 10 7a3.82 3.82 0 00-2.85 1A4.67 4.67 0 006 11.5c0 3.91 2.5 4.5 4 4.5zM23 12c-1.5 0-4-.59-4-4.5A4.67 4.67 0 0120.15 4 3.73 3.73 0 0123 3c1.49 0 4 .59 4 4.5a4.69 4.69 0 01-1.15 3.5A3.86 3.86 0 0123 12zm0-2a2 2 0 001.43-.44A2.94 2.94 0 0025 7.5c0-2.08-.77-2.5-2-2.5a2.05 2.05 0 00-1.44.44A2.92 2.92 0 0021 7.5c0 2.08.77 2.5 2 2.5z" })));
}
exports.default = SvgUsersFilled;
//# sourceMappingURL=UsersFilled.js.map